// extracted by mini-css-extract-plugin
export default {"container":"ratings_container__5dOyT","overlay":"ratings_overlay__TQBfl"};